// default app vars
let g_dev = true;
let g_windowHeight = window.offsetHeight;
let g_windowWidth = window.offsetWidth;
let g_scroll = window.pageYOffset;

// custom vars
let scrollMargin = 0;
let scrollTreshold = 0;

window.addEventListener('scroll', function(event){
    g_scroll = window.pageYOffset;
});

window.addEventListener('resize', function(event){
    g_windowHeight = window.offsetHeight;
    g_windowWidth = window.offsetWidth;
});

if(typeof(document.querySelector('.splide-winners')) != 'undefined' && document.querySelector('.splide-winners') != null) {
    var splideWinners = new Splide('.splide-winners', {
        lazyLoad: 'nearby',
        preloadPages: 0,
        autoHeight: true,
        autoplay: false,
        pagination: false,
        perPage: 5,
        gap: '1em',
        breakpoints: {
            960: {
                perPage: 3,
            },
            480: {
                perPage: 2,
            },
        }
    }).mount();
}

